import { RTL_LOCALES } from '../lang'

// Keep in sync with the backend rule: 'image' => 'nullable|image|mimes:jpeg,jpg,png,gif,webp,bmp|max:51200'
export const ALLOWED_IMAGE_EXTENSIONS = ['jpeg', 'jpg', 'png', 'gif', 'webp', 'bmp']

export function isAllowedImageExtension(filename) {
  if (!filename) return false
  const ext = filename.split('.').pop().toLowerCase()
  return ALLOWED_IMAGE_EXTENSIONS.includes(ext)
}

// The backend (ApiController::storeImage) downsizes every order image to 1440px anyway, so
// shrinking it in the browser first turns a 5-25MB phone photo into a ~300KB upload without
// any visible loss. GIFs pass through untouched (re-encoding would drop the animation).
// Resolves with the original file if the browser can't decode it or the result isn't smaller.
export const IMAGE_UPLOAD_MAX_DIMENSION = 1440

export function compressImageFile(file, maxDimension = IMAGE_UPLOAD_MAX_DIMENSION, quality = 0.85) {
  if (!file || /\.gif$/i.test(file.name)) return Promise.resolve(file)

  return new Promise(function (resolve) {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = function () {
      const scale = Math.min(1, maxDimension / Math.max(img.naturalWidth, img.naturalHeight))
      const canvas = document.createElement('canvas')
      canvas.width = Math.max(1, Math.round(img.naturalWidth * scale))
      canvas.height = Math.max(1, Math.round(img.naturalHeight * scale))
      const ctx = canvas.getContext('2d')
      // JPEG has no alpha — paint white first so transparent PNG areas don't turn black.
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      URL.revokeObjectURL(url)
      canvas.toBlob(function (blob) {
        if (!blob || blob.size >= file.size) return resolve(file)
        const name = file.name.replace(/\.[^.]+$/, '') + '.jpg'
        resolve(new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() }))
      }, 'image/jpeg', quality)
    }
    img.onerror = function () {
      URL.revokeObjectURL(url)
      resolve(file)
    }
    img.src = url
  })
}

// IQD notes only come in 250 denominations, so any USD->IQD conversion shown on an
// invoice/receipt is rounded to the nearest 250. Always rounds UP (e.g. 550 -> 750,
// never down to 500) so a converted total never shows less than what's actually owed.
export function roundUpIqd(value) {
  return Math.ceil((Number(value) || 0) / 250) * 250
}

export default {
  methods: {
    $_image_path() {
      return this.getFilePath + '/images/'
    },

    // jQuery PrintMe opens a *separate* window/document that only ever loads the
    // stylesheets listed here -- it does not inherit the main app's bundled CSS (or
    // even <html dir="...">), so print_style.css's RTL mirror has to be added to this
    // list explicitly rather than relying on the src/lang/index.js <link> injection.
    $_print_stylesheet_paths() {
      const paths = ['assets/ltr/css/print_style.css']
      if (RTL_LOCALES.includes(this.$i18n.locale)) {
        paths.push('assets/rtl/css/print_style.css')
      }
      return paths
    },

    $_has_perm(permissionCode) {
      const authUserPermissions = JSON.parse(localStorage.getItem('user_permissions'))

      for (const index in authUserPermissions) {
        if (permissionCode === authUserPermissions[index].code) {
          return true
        }
      }

      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/helpers.js